var React = require('react');

function IconHome (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Home"),React.createElement("path",{"d":"M15.5360502,6.23510972 L5.0815047,14.9592476 L4,13.661442 L15.5360502,4 L27,13.661442 L25.9184953,14.9592476 L15.5360502,6.23510972 Z M9.47962382,23.9717868 L13.3730408,23.9717868 L13.3730408,18.2758621 L17.6269592,18.2758621 L17.6269592,23.9717868 L21.5924765,23.9717868 L21.5924765,14.0219436 L23.322884,14.0219436 L23.322884,25.7021944 L7.7492163,25.7021944 L7.7492163,14.0219436 L9.47962382,14.0219436 L9.47962382,23.9717868 Z","id":"Shape","key":1})]);
}

IconHome.defaultProps = {"width":"30px","height":"30px","viewBox":"0 0 30 30","version":"1.1"};

module.exports = IconHome;

IconHome.default = IconHome;
